import {
  Container,
  Title,
  Accordion,
  AccordionItem,
  AccordionControl,
  AccordionPanel,
} from "@mantine/core";
import { Trans, useTranslation } from "react-i18next";
import classes from "./Faq.module.css";
import mixpanel from "mixpanel-browser";

function TrackingAccordionItem({ children, value, ...props }) {
  return (
    <AccordionItem
      className={classes.item}
      onClick={() => {
        mixpanel.track("faq", { value });
      }}
      value={value}
      {...props}
    >
      {children}
    </AccordionItem>
  );
}
export default function Faq() {
  const { t } = useTranslation("common");

  return (
    <Container size="sm" className={classes.wrapper}>
      <Title ta="center" className={classes.title}>
        {t("payment.faq.title")}
      </Title>

      <Accordion variant="separated">
        <TrackingAccordionItem value="payment">
          <AccordionControl>
            {t("payment.faq.howToPay.question")}
          </AccordionControl>
          <AccordionPanel>{t("payment.faq.howToPay.answer")}</AccordionPanel>
        </TrackingAccordionItem>

        <TrackingAccordionItem value="subscription-required">
          <AccordionControl>
            {t("payment.faq.subscriptionRequired.question")}
          </AccordionControl>
          <AccordionPanel>
            {t("payment.faq.subscriptionRequired.answer")}
          </AccordionPanel>
        </TrackingAccordionItem>

        {/* <TrackingAccordionItem value="subscription-benefits">
          <AccordionControl>
            What are the benefits of a subscription?
          </AccordionControl>
          <AccordionPanel>
            Subscription credit prices are lower than one-time purchases.
          </AccordionPanel>
        </TrackingAccordionItem> */}

        <TrackingAccordionItem value="subscription-benefits">
          <AccordionControl>
            {t("payment.faq.paymentFailed.question")}
          </AccordionControl>
          <AccordionPanel>
            <Trans
              i18nKey="payment.faq.paymentFailed.answer"
              components={[<a key="0" href="mailto:support@facetflux.com" />]}
            />
          </AccordionPanel>
        </TrackingAccordionItem>

        <TrackingAccordionItem value="refund">
          <AccordionControl>{t("payment.faq.refund.question")}</AccordionControl>
          <AccordionPanel>{t("payment.faq.refund.answer")}</AccordionPanel>
        </TrackingAccordionItem>

        <TrackingAccordionItem value="price">
          <AccordionControl>{t("payment.faq.cost.question")}</AccordionControl>
          <AccordionPanel>
            <Trans
              i18nKey="payment.faq.cost.answer"
              components={[<a key="0" href="#pricing" />]}
            />
          </AccordionPanel>
        </TrackingAccordionItem>
      </Accordion>
    </Container>
  );
}
